import * as React from 'react';
const SvgSortDown = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M18.966 5.493H5.009c-2.668 0-4.02 3.24-2.12 5.125l7.002 7.009a3.002 3.002 0 0 0 4.248 0l7.01-7.01c1.822-1.883.545-5.124-2.183-5.124Zm-7.01 10.012L4.949 8.496h14.018l-7.01 7.01Z", fill: "currentColor" })));
export default SvgSortDown;
